import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
 import Header from './Header';
 import HomePage from './HomePage';
 import Profile from './Profile';
 import Wallet from './wallet';
 import TransactionHistory from './TransactionHistory';
 import Refer from './Refer';
 import Support from './Support';
 import Kyc2 from './Kyc2';
 import Kyc3 from './ky3';
 import Redeem from './Redeem';
 import AddCase from './AddCase';
 import LudoKing from './LudoKing';
 import Rule from './Rule';  
 import RoomJoin from './RoomJoin';
 import logo from './image/logo.jpg'
 import Register from './Register';
 import Login from './Login';
 import WalletAdd from './walletAdd'
 import WithdrawalOptions from './WithdrawalOptions';
 import TermsAndConditions from './TermsAndConditions';
 import PrivacyPolicy from './PrivacyPolicy';
 import RefundPolicy from './RefundPolicy';
import Gst from './Gst';
import ProtectedRoute from './protectedRoute';

const AppRoutes = () => {
  const isAuthenticated = localStorage.getItem("token");

  const navigate = useNavigate();
  

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const tokenExpiration = JSON.parse(atob(token.split('.')[1])).exp * 1000;
      const currentTime = Date.now();

      if (currentTime > tokenExpiration) {
        // Token expired, alert the user and redirect
        alert("Your session has expired. Please log in again.");
        localStorage.removeItem("token");
        navigate("/");
      }
    }
  }, [navigate]);

  useEffect(() => {
    const path = window.location.pathname;

    // Check if the URL contains '/admin'
    if (path.includes('/admin')) {
      window.location.href = 'https://backend.brothersludo.in/admin'; // Redirect to the backend
    }
  }, []);


  const location = useLocation(); 
 const noHeaderRoutes = ["/signup", "/","/terms","/PrivacyPolicy"];


  return (

<div> 
    <div className='container-fluid '>
         <div className='row '>
          <div className='col-lg-5 col-md-5 col-sm-12 px-0 ' style={{borderRight:'8px solid #e0e0e0', paddingTop:'30px'}}>
          {!noHeaderRoutes.includes(location.pathname) && <Header />}
    <Routes>
      {/* If user is already authenticated, redirect to home */}
      <Route  path="/"  element={isAuthenticated ? <Navigate to="/home" /> : <Login />}
      />
      <Route path="/signup" element={<Register />} />
      
      {/* Protected routes */}
      <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/wallet"
        element={
          <ProtectedRoute>
            <Wallet />
          </ProtectedRoute>
        }
      />
      <Route
        path="/transaction-history"
        element={
          <ProtectedRoute>
            <TransactionHistory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/refer"
        element={
          <ProtectedRoute>
            <Refer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/support"
        element={
          <ProtectedRoute>
            <Support />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ky2"
        element={
          <ProtectedRoute>
            <Kyc2 />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ky3"
        element={
          <ProtectedRoute>
            <Kyc3 />
          </ProtectedRoute>
        }
      />
      <Route
        path="/redeem"
        element={
          <ProtectedRoute>
            <Redeem />
          </ProtectedRoute>
        }
      />
      <Route
        path="/addcase"
        element={
          <ProtectedRoute>
            <AddCase />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ludoking"
        element={
          <ProtectedRoute>
            <LudoKing />
          </ProtectedRoute>
        }
      />
      <Route path="/rule" element={<Rule />} />
      <Route path="/room" element={<RoomJoin />} />
      <Route path="/wallet-add" element={<WalletAdd />} />
      <Route path="/withdrawal" element={<WithdrawalOptions />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
      <Route path="/RefundPolicy" element={<RefundPolicy />} />
      <Route path="/gst" element={<Gst />} />
    </Routes>
    </div>


           <div className='col-7  d-none d-md-block ' style={{overflow:'hidden', }}>
           <div style={{position:'fixed', top:'40%', left:'60%',  textAlign:'center',  }}>
             <img src={logo}  style={{  textAlign:'center', width:'100px'}}></img>
             <h5 className='mt-4'>Brothersludo Win Real Cash</h5>
           </div>
           </div>
         </div>
       </div> 

    </div>
  );
};

export default AppRoutes;











// import React, { useEffect } from 'react'
// import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
// import Header from './Header';
// import HomePage from './HomePage';
// import Profile from './Profile';
// import Wallet from './wallet';
// import TransactionHistory from './TransactionHistory';
// import Refer from './Refer';
// import Support from './Support';
// import Kyc2 from './Kyc2';
// import Kyc3 from './ky3';
// import Redeem from './Redeem';
// import AddCase from './AddCase';
// import LudoKing from './LudoKing';
// import Rule from './Rule';  
// import RoomJoin from './RoomJoin';
// import logo from './image/logo.jpg'
// import Register from './Register';
// import Login from './Login';
// import WalletAdd from './walletAdd'
// import WithdrawalOptions from './WithdrawalOptions';
// import TermsAndConditions from './TermsAndConditions';
// import PrivacyPolicy from './PrivacyPolicy';
// import RefundPolicy from './RefundPolicy';
// import Gst from './Gst'; 

// const App = () => {
//   const location = useLocation();
//   const navigate = useNavigate()
//   const noHeaderRoutes = ["/signup", "/","/terms","/PrivacyPolicy"];


//   const Navigate= useNavigate()
//   useEffect(() => { 
//     if(!localStorage.getItem('token')){ 
//         Navigate("/") 
//     }
//   }, [])
 
//   return (
//     <div>
//  {/* <Header  /> */}


//  <div className='container-fluid '>
//         <div className='row '>
//           <div className='col-lg-5 col-md-5 col-sm-12 px-0 ' style={{borderRight:'8px solid #e0e0e0', paddingTop:'30px'}}>
//           {!noHeaderRoutes.includes(location.pathname) && <Header />}
     
     
//          <Routes>
//          <Route path="/" element={<Login />}/> 
//          <Route path="/home" element={<HomePage />}/> 
//           <Route path="/signup" element={<Register/>} />  
//           {/* <Route path="/signin" element={<Login/>} />   */}
//           <Route path="/profile" element={<Profile />} /> 
//           <Route path="/wallet" element={<Wallet/>} /> 
//           <Route path="/transaction-history" element={<TransactionHistory/>} /> 
//           <Route path="/refer" element={<Refer/>} /> 
//           <Route path="/support" element={<Support/>} /> 
//           <Route path="/ky2" element={<Kyc2/>} /> 
//           <Route path="/ky3" element={<Kyc3/>} /> 
//           <Route path="/redeem" element={<Redeem/>} /> 
//           <Route path="/addcase" element={<AddCase/>} /> 
//           <Route path="/ludoking" element={<LudoKing/>} /> 
//           <Route path="/rule" element={<Rule/>} />  
//           <Route path="/room" element={<RoomJoin/>} />  
//           <Route path="/wallet-add" element={<WalletAdd/>} />  
//           <Route path="/withdrawal" element={<WithdrawalOptions/>} />  
//           <Route path="/terms" element={<TermsAndConditions/>} />  
//           <Route path="/PrivacyPolicy" element={<PrivacyPolicy/>} />  
//           <Route path="/RefundPolicy" element={<RefundPolicy/>} />  
//           <Route path="/gst" element={<Gst/>} />    
//           </Routes>
     
//           </div>


//           <div className='col-7  d-none d-md-block ' style={{overflow:'hidden', }}>
//           <div style={{position:'fixed', top:'40%', left:'60%',  textAlign:'center',  }}>
//             <img src={logo}  style={{  textAlign:'center', width:'100px'}}></img>
//             <h5 className='mt-4'>Brothersludo Win Real Cash</h5>
//           </div>
//           </div>
//         </div>
//       </div> 

//     </div>
//   )
// }

// export default App;